export const OPSREVIEW_DAY_OF_WEEK = 2;

export const OPSREVIEW_WEEKLY_ENTRY_TABLE = "ops-review-weekly";
export const OPSREVIEW_REVIEWED_INCIDENTS_TABLE =
  "ops-review-reviewed-incidents";
export const OPSREVIEW_OWNERSHIP_TABLE = "ops-review-ownership";
export const OPSREVIEW_HISTORY_TABLE = "ops-review-history";

export const OPSREVIEW_JIRA_LABELS =
  "opsreview,opsreview-exceptions,opsreview-queries,opsreview-specs,opsreview-security,opsreview-postmortem";
export const OPSREVIEW_JIRA_FIELDS =
  "summary,labels,assignee,issuetype,status,priority,created";

export const VIOLATION_TABLE = {
  datadog: {
    missing_slos: {
      code: "missing_slos",
      display: "Missing SLO Data",
    },
    slo_below_threshold: {
      code: "slo_below_threshold",
      display: "SLO Beyond Threshold",
    },
    test_retries: {
      code: "test_retries",
      display: "Top 10 Test Retries (Flaky)",
    },
    has_incidents: {
      code: "has_incidents",
      display: "Has Unreviewed Incidents",
    },
  },
  honeybadger: {
    missing_project_key_or_query: {
      code: "missing_project_key_or_query",
      display: "Missing ProjectKey or Query Data",
    },
    faults_above_threshold: {
      code: "faults_above_threshold",
      display: "Fault Beyond Threshold",
    },
  },
  opsgenie: {
    has_incidents: {
      code: "has_incidents",
      display: "Incidents",
    },
  },
  kajabi: {
    missing_catalog_info: {
      code: "missing_catalog_info",
      display: "Missing Catalog Info Document",
    },
  },
};

export const OPSGENIE_EXTRANEOUS_RESPONDERS = [
  "8d5aea75-6460-4439-8db8-2ce8987b11bc", // Incident Managers
  "cb090499-5cff-41a5-afdd-b2a695ee73cf", // Communications Officer
  "8f683002-bac7-4cb6-9762-f26805081c2b", // Executives
  "454a765c-43f9-4986-a2e0-a7a91ddf220d", // Support
];
